<template>
  <div :class="'p-4 md:p-8 tool-card border-t-8 border-t-tool-'+tool+' shadow'">
    <slot/>
  </div>
</template>
<script>
export default {
  name: "base-card",
  props:{
    tool: String,
  }
};
</script>
